import Vue from 'vue'
import Vuex from 'vuex'

import executionRules from './modules/executionRules'
import campaignDesigner from './modules/campaignDesigner'
import domainTablesConfiguration from './modules/domainTablesConfiguration'
import jobs from './modules/jobs'
import salesQueryBuilder from './modules/salesQueryBuilder'
import session from './modules/session'
import settings from './modules/settings'
import userManagement from './modules/userManagement'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    campaignDesigner,
    domainTablesConfiguration,
    executionRules,
    jobs,
    salesQueryBuilder,
    session,
    settings,
    userManagement
  }
})
